import { ViewerComponent } from "./Landing";

const TermsOfAgreement = () => {
    return   <div style={{ marginTop: 0, backgroundColor: '#fff', paddingTop: '20px', height: '100vh', borderRadius: '10px' }}>
        <div style={{display: 'flex', justifyContent: 'center', fontWeight: 600, marginBottom: 10}}><span>Điều khoản thoả thuận</span></div>
          <ViewerComponent fileUrl={'pdf/dieu-khoan-thoa-thuan.pdf'} />
     </div>
}

export default TermsOfAgreement;